
import {defineComponent} from "vue"
import "bootstrap/dist/css/bootstrap.min.css"
import "@/assets/styles.scss"
import CityList from "@/components/CityList.vue";

export default defineComponent({
  components: {
    CityList
  },
  props: {
    sef_url: {
      default: "",
      type: String
    }
  },
  provide(){
    return {
      sef_url: this.sef_url
    }
  }
})
